import React from 'react';
import './index.css';
import App from './components/app/App';

const MtUmet = () => <App />;

export default {
  routeProps: {
    path: '/mt-umet',
    component: MtUmet,
  },
  name: 'MtUmet',
  label: 'Debug Tool',
  iconClassName: 'icon-bug',
  active: true,
};
